import Input from "@/components/Input";
import Button from "@/components/Button";
import Background from "@/assets/images/contact-card.png";
import { forwardRef, useState } from 'react';
import { whatsappConfig } from '@/screens/services/WhatsappConfig';
import { useTranslation } from 'react-i18next';

const Contact = forwardRef<HTMLElement>((_, ref) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [question, setQuestion] = useState('');
  const [errors, setErrors] = useState({ name: false, question: false });

  const validateForm = (): boolean => {
    const newErrors = {
      name: name.trim() === '',
      question: question.trim() === ''
    };
    
    setErrors(newErrors);
    return !newErrors.name && !newErrors.question;
  };

  const handleWhatsAppClick = () => {
    // Validate form before proceeding
    if (!validateForm()) {
      return; // Stop if validation fails
    }
    
    // Use the global WhatsApp config
    const message = whatsappConfig.formatMessage.contact({ name, question });
    whatsappConfig.openWhatsApp(message);
  };

  return (
    <section ref={ref} id="contact" className="min-h-screen flex flex-col py-16">
        <div className="flex flex-1 flex-col m-8 md:flex-row overflow-hidden rounded-xl shadow-lg">
          <div style={styles.leftSection} className="basis-1/3 p-8 md:p-12 lg:p-20 text-white">
            <div style={styles.overlay}></div>
              <h1>{t('contact.title')}</h1>
              <div className="mt-6">
                  <h4 className="mb-2">{t('contact.operatingHours')}</h4>
                  <p className="mb-2 font-semibold">{t('contact.days')}</p>
                  <p className="mb-2 font-semibold">{t('contact.including')}</p>
                  <p className="mb-2 font-semibold">{t('contact.hours')}</p>
              </div>
          </div>
          <div className="flex p-8 lg:p-20 md:p-12 gap-4 flex-col basis-2/3 items-start md:items-end">
                <Input
                  label={t('contact.nameLabel')}
                  placeholder={t('contact.namePlaceholder')}
                  className="w-full flex-none"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={errors.name ? t('contact.nameRequired') : ""}
                />
                <Input
                  label={t('contact.questionLabel')}
                  placeholder={t('contact.questionPlaceholder')}
                  className="w-full flex-1"
                  rows={5}
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  error={errors.question ? t('contact.questionRequired') : ""}
                />
              <div className="flex-none w-full flex justify-start md:justify-end mt-4 pb-4">
                <Button
                  className="bg-primary-blue"
                  text={t('contact.submitButton')}
                  active={true}
                  onClick={handleWhatsAppClick}
                />
              </div>
          </div>
        </div>
    </section>
  )
})

const styles : { [key: string]: React.CSSProperties } = {
  leftSection: {
    position: "relative",
    backgroundImage: `url(${Background})`,
    backgroundSize: "cover",
    isolation: "isolate", // Creates a new stacking context
  },
  overlay: {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.35)",
    zIndex: -1
  }
}

export default Contact